import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Logout.css";
import { getUser, logout } from '../../scripts/auth';


const Logout = () => {
    const navigate = useNavigate();
    const [menuHidden, setMenuHidden] = useState(true)

    const user = getUser();

    const handleLogout = async () => {
        if (await logout()) {
            navigate("/login")
        }
    };

    return (
        <div className='logout-box' onMouseLeave={()=>setMenuHidden(true)}>
            <button className='user-button' onMouseEnter={()=>setMenuHidden(false)} >
                <img className='icon' src="/icons/user.png" alt="User Icon"/>
            </button>
            <div className='content'>
                <label className='account'>{user.account}</label>
                <label>{user.username}</label>
            </div>
            <menu hidden={menuHidden} onMouseEnter={()=>setMenuHidden(false)}>
                <div>Account</div>
                <div onClick={handleLogout}>Logout</div>
            </menu>
        </div>
    );
};

export default Logout;